import React from "react";

import { Flex } from "@chakra-ui/react";

import {
  StyledCardBody,
  StyledCardFooter,
  StyledCardHeader,
  StyledCardWrapper,
} from "./style";
import { TCardProps } from "./types";

export const Card: React.FC<TCardProps> = ({
  header,
  body,
  footer,
  cardStyle,
  cardCss,
  cardInnerCss,
}) => {
  return (
    <StyledCardWrapper
      width={cardStyle?.cardWidth}
      css={cardCss}
    >
      <Flex
        flexDir={"column"}
        {...(!cardInnerCss && { gap: 3 })}
        css={cardInnerCss}
      >
        {header && <StyledCardHeader>{header}</StyledCardHeader>}
        <StyledCardBody>{body}</StyledCardBody>
        {footer && <StyledCardFooter>{footer}</StyledCardFooter>}
      </Flex>
    </StyledCardWrapper>
  );
};
